import React from 'react'

export default function MXujjatlar() {
  return (
    <div>
      <div className="container">
      </div>
    </div>
  )
}
